import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center" }

import { cn } from '@/lib/utils';
    import { Circle } from 'lucide-vue-next';
    import {
        DropdownMenuItemIndicator,
        DropdownMenuRadioItem,
        type DropdownMenuRadioItemEmits,
        type DropdownMenuRadioItemProps,
        useForwardPropsEmits,
    } from 'reka-ui';
    import { computed, reactive, type HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownMenuRadioItem',
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return reactive(delegated);
    });

    const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenuRadioItem), _mergeProps({ "data-slot": "dropdown-menu-radio-item" }, _unref(forwarded), {
    class: 
            _unref(cn)(
                `focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
                props.class,
            )
        
  }), {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(DropdownMenuItemIndicator), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Circle), { class: "size-2 fill-current" })
          ]),
          _: 1
        })
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})